:host {
  /**
   * @prop --color: Text color of the title
   */
  --color: initial;
  display: flex;
  flex: 1;
  align-items: center;
  transform: translateZ(0);
  color: var(--color);
}

:host(.ion-color) {
  color: var(--ion-color-base);
}

.toolbar-title {
  display: block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  pointer-events: auto;
}

:host(.title-small) .toolbar-title {
  white-space: normal;
}

:host {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.0125em;
}
@supports (margin-inline-start: 0) or (-webkit-margin-start: 0) {
  :host {
    padding-left: unset;
    padding-right: unset;
    -webkit-padding-start: 20px;
    padding-inline-start: 20px;
    -webkit-padding-end: 20px;
    padding-inline-end: 20px;
  }
}

:host(.title-small) {
  width: 100%;
  height: 100%;
  font-size: 15px;
  font-weight: normal;
}